import { ROOT, SUPPLIER_GET_ALL_BOOKING_SITE, SUPPLIER_GET_ALL_BOOKING_HOTEL, SUPPLIER_GET_BOOKING_DETAIL_HOTEL, SUPPLIER_GET_BOOKING_DETAIL_TICKET } from "@/_helpers/constant.js";

import { requestOptions, handleResponse } from "@/_helpers";

function getBookingHotel(body) {
    return fetch(ROOT + SUPPLIER_GET_ALL_BOOKING_HOTEL, requestOptions.post(body))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getBooingSite(body) {
    return fetch(ROOT + SUPPLIER_GET_ALL_BOOKING_SITE, requestOptions.post(body))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getBookingDetailHotel(code) {
    return fetch(ROOT + SUPPLIER_GET_BOOKING_DETAIL_HOTEL + `/` + code, requestOptions.get())
        .then(handleResponse);
}
function getBookingDetailTicket(code) {
    return fetch(ROOT + SUPPLIER_GET_BOOKING_DETAIL_TICKET + `/` + code, requestOptions.get())
        .then(handleResponse);
}

export const bookingService = {
    getBooingSite,
    getBookingHotel,
    getBookingDetailHotel,
    getBookingDetailTicket
};
